import { useRouter } from "next/router";
import constants from "../utils/constants";
function useCheckLCContainer() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  return pathname.includes(constants.SCREENS.LUNGCANCER);
}
export default useCheckLCContainer;